'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _ListGroup = require('react-bootstrap/lib/ListGroup');

var _ListGroup2 = _interopRequireDefault(_ListGroup);

var _searchResultItem = require('./search-result-item');

var _searchResultItem2 = _interopRequireDefault(_searchResultItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResults = function SearchResults(_ref) {
  var results = _ref.results,
      onSelectItem = _ref.onSelectItem;

  if (results.size === 0) {
    return null;
  }

  return _react2.default.createElement(
    _ListGroup2.default,
    { fill: true },
    results.map(function (item, k) {
      return _react2.default.createElement(_searchResultItem2.default, { key: k, item: item, onSelectItem: onSelectItem });
    })
  );
};

process.env.NODE_ENV !== "production" ? SearchResults.propTypes = {
  results: _propTypes.object,
  onSelectItem: _propTypes.func
} : void 0;

exports.default = SearchResults;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-row-search/lib/search-results.js
// module id = 625
// module chunks = 0